import { cn } from "@/lib/utils";

export default function PageHero({ eyebrow, title, desc, Art, actions, children, testid, compact }) {
  return (
    <section data-testid={testid} className="fade-up mb-8 overflow-hidden rounded-xl border-2 border-ink bg-white">
      <div className="awning" />
      <div className={cn("relative flex flex-col gap-5 px-5 pb-6 pt-8 md:flex-row md:items-end md:px-8", compact && "pb-5 pt-7")}>
        <div className="min-w-0 flex-1">
          {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
          <h1 className="font-display text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl">{title}</h1>
          {desc && <p className="mt-3 max-w-xl text-sm text-zinc-600 md:text-base">{desc}</p>}
          {actions && <div className="mt-5 flex flex-wrap gap-2">{actions}</div>}
        </div>
        {Art && <Art className={cn("hidden shrink-0 text-ink sm:block", compact ? "h-24 w-36" : "h-32 w-44 lg:h-36 lg:w-52")} />}
      </div>
      {children}
    </section>
  );
}
